'use strict';

const decoded = _.reduce({
    mailtoContato:  ['contato', 'Contato accede.com.br'],
    mailtoWork:     ['contato', 'Trabalhe Conosco accede.com.br']
}, (r, v, k) =>
    _.assign(r, {[k]: `mailto:${v[0]}@accede.com.br?subject=${v[1]}`}), {});

export default decoded;



// WEBPACK FOOTER //
// ./app/decoded.js